<script>
	import Modal from '@/pages/components/modal.vue';
	import { useForm } from '@inertiajs/vue3';
	import UpdateForm from "@/mixins/shared/updateForm";
	import Input from "@/pages/components/form/input-only/input.vue";
	import Textarea from "@/pages/components/form/input-only/textarea.vue";
	import Wysiwyg from "@/pages/components/form/input-only/wysiwyg.vue";
	import Select from "@/pages/components/form/input-only/select.vue";
	import Translate from "@/helpers/Translate.js";

	export default {
		mixins: [UpdateForm],
		data() {
			let defaults = {
				identifier: null,
				groups: {},
			};
			return {
				key: Math.random(),
				type: '',
				group: '',
				groups: {},
				value: '',
				initialized: false,
				defaults: defaults,
				form: useForm(defaults)
			}
		},
		components: { Modal, Wysiwyg, Input, Textarea, Select },
		mounted() {
			$(window).off('.translate-modal').on('wwdev.translations.edit.translate-modal', (event, identifier, group, type) => this.open(identifier, group, type));
			this.$watch('group', (newValue, oldValue) => {
				this.value = this.getGroupValue(newValue, 'nl');
			});
		},
		methods: {
			async open(identifier, group, type) {
				this.group = group;
				this.type = type;
				this.formRoute = route('api.v1.translations.update', { identifier: identifier });

				try {
					let response = await Helpers.Ajax.get(route('api.v1.translations.show', { identifier: identifier }));

					this.groups = response.data.groups;
					this.form.defaults({
						identifier: identifier,
						groups: response.data.translations,
					});
					this.form.reset();

					this.value = this.getGroupValue(group, 'nl');

					await this.$nextTick();

					this.key = Math.random();
					this.initialized = true;
					this.$refs.modal.open();
				} catch (error) {
					console.error(error);
					Helpers.Alert.alert('Er is een fout opgetreden bij het laden van de vertaling');
				}
			},

			async close() {
				await this.$refs.modal.close();
				this.reset();
			},

			async reset() {
				this.initialized = false;
				this.value = '';
				this.groups = {};
				this.form.defaults(this.defaults);
				this.form.reset();
			},

			submitForm() {
				if (!this.form.groups[this.group]) {
					this.form.groups[this.group] = {};
				}
				this.form.groups[this.group]['nl'] = this.value;
				this.submit();
			},

			afterSuccess(form, response) {
				this.close();
				Translate.updateTranslations();
			},

			getGroupValue(group, languageCode) {
				if (this.form.groups[group] && this.form.groups[group][languageCode]) {
					return this.form.groups[group][languageCode];
				} else if(this.form.groups['algemeen'] && this.form.groups['algemeen'][languageCode]) {
					return this.form.groups['algemeen'][languageCode];
				} else if (this.form.groups['algemeen'] && this.form.groups['algemeen']['nl']) {
					return this.form.groups['algemeen']['nl'];
				}
				return '';
			}
		}
	}
</script>

<template>
	<Modal :settings="{focus: false}" title="Tekst bewerken" size="lg" id="translation-modal" ref="modal">
		<form v-if="initialized" id="translation-modal-form" @submit.prevent="this.submitForm">
			<template v-if="Object.keys(groups).length > 1">
				<div class="mb-3">
					<label class="mb-1" for="translation-modal-group">Groep</label>
					<Select
						:key="key"
						v-model="group"
						id="translation-modal-group"
						name="translation-modal-group"
						data-minimum-results-for-search="5"
						:options="Object.entries(groups).map(([key, value]) => ({ value: key, label: value }))" />
				</div>
			</template>

			<label class="mb-1" for="translation-modal-value">Tekst</label>

			<template v-if="type == 'text'">
				<Input
					:form="form"
					v-model="value"
					id="translation-modal-value"
					:name="`groups.${this.group}.nl`" />
			</template>

			<template v-if="type == 'textarea'">
				<Textarea
					:form="form"
					v-model="value"
					id="translation-modal-value"
					:name="`groups.${this.group}.nl`" />
			</template>

			<template v-if="type == 'html'">
				<Wysiwyg
					:form="form"
					v-model="value"
					id="translation-modal-value"
					:name="`groups.${this.group}.nl`" />
			</template>
		</form>

		<template #footer>
			<button type="button" class="btn btn-secondary" @click.prevent="this.close">Annuleren</button>
			<button
				form="translation-modal-form"
				type="submit"
				class="btn btn-primary"
				@click.prevent="this.submitForm">
				Opslaan
			</button>
		</template>
	</Modal>
</template>